import { makeStyles } from '@material-ui/styles';
import { colors } from '../../../style/colors';
import { ITheme } from '../../../style/theme';

export const useStyles = makeStyles<ITheme>((theme) => ({
  contentContainer: {
    padding: '0 24px',
  },
  mentorsListWrapper: {
    paddingTop: '24px',
  },
  videoCallDetails: {
    marginBottom: 42,
  },
  backLink: {
    fontWeight: 'normal',
  },
  pageHeaderLink: {
    paddingLeft: 4,
  },
  pageTitle: {
    fontWeight: 700,
    paddingLeft: 4,
  },
  descriptionWrapper: {
    maxWidth: 718,
    padding: '16px 0',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  callInfo: {
    color: colors.darkGray,
    textTransform: 'uppercase',
  },
  iconsContainer: {
    paddingTop: 8,
    [theme.breakpoints.down('xs')]: {
      textAlign: 'left',
    },
  },
  iconWrapper: {
    verticalAlign: 'middle',
    marginTop: 8,
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  mentorsSection: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '16px 0',
    [theme.breakpoints.up(1300)]: {
      width: 1200,
    },
    [theme.breakpoints.down(780)]: {
      display: 'block',
    },
  },

  learnMore: {
    color: colors.darkestBlue,
    fontWeight: 700,
    cursor: 'pointer',
  },
  item: {
    paddingRight: 24,
    paddingBottom: 24,
    [theme.breakpoints.down('xs')]: {
      paddingRight: 0,
    },
  },
}));
